import { Beneficio } from 'src/app/models/beneficio.model';
import { BeneficioService } from 'src/app/services/class/beneficio.service';
// default
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoadingService } from './../../services/loading.service';
import { HelperService } from './../../services/helper.service';
import { HttpProgressEvent } from '@angular/common/http';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-beneficios-criar',
  templateUrl: './beneficios-criar.component.html',
  styleUrls: ['./beneficios-criar.component.scss']
})
export class BeneficiosCriarComponent implements OnInit {

  data: Beneficio = new Beneficio();

  file: File;
  progress: any;

  constructor(
    public helper: HelperService,
    public beneficioService: BeneficioService,
    public loadingService: LoadingService,
    public router: Router
  ) {
  }

  ngOnInit() {
  }

  submit(f: NgForm) {

    if (f.invalid) {
      this.helper.formMarkAllTouched(f);
      this.helper.openSnackBar('Preencha os campos requiridos, por favor!');
      return;
    }

    this.loadingService.present('Inserindo...');

    this.beneficioService.post(this.data)
      .subscribe((res: any) => {
        // a imagem ja foi enviada ao selecionar o arquivo, e a URL esta em data.icone
        this.router.navigate(['/beneficios']).then(() => {
          this.helper.openSnackBar('Item inserido com sucesso.');
          this.loadingService.dismiss();
        })
      }, e => {
        this.helper.openSnackBar(e.error);
        this.loadingService.dismiss()
      });

  }

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef;
  onFileSelected(files) {
    this.file = files.item(0);
    this.loadingService.present('0%');
    this.submitImages(this.file, '/beneficio/icone?id=-99').then((res: any) => {
      this.data.icone = res.body;
      this.loadingService.dismiss();
    }).catch(() => {
      this.progress = 0;
      this.fileInput.nativeElement.value = '';
      this.loadingService.dismiss();
    });
  }

  submitImages(file: File, url: string) {
    if (!file) {
      return;
    }
    return new Promise((resolve, reject) => {
      this.beneficioService.postFile(file, url, 'image')
        .subscribe((event: HttpProgressEvent | any) => {
          if (event.type === 4) {
            this.progress = 0;
            resolve(event);
          } else {
            this.progress = Math.round((event.loaded / event.total) * 100);
            if (isNaN(this.progress)) {
              this.progress = 100;
            }
            this.loadingService.title = `${this.progress}%`;
          }
        }, err => reject(err));
    });
  }

  removeIcone() {
    this.data.icone = '';
  }

}
